import { AppProviders } from "./AppProviders";
import { AppRoutes } from "./AppRoutes";
import { useAppInitialization } from "./hooks/useAppInitialization";
import { InitErrorPage } from "./pages/InitErrorPage";
import { LoadingPage } from "./pages/LoadingPage";

export function App() {
  const { authConfig, i18nInstance, isLoading, initError, retry } =
    useAppInitialization();

  if (initError) {
    return <InitErrorPage error={initError} onRetry={retry} />;
  }

  if (isLoading || !authConfig || !i18nInstance) {
    return <LoadingPage />;
  }

  return (
    <AppProviders authConfig={authConfig} i18nInstance={i18nInstance}>
      <AppRoutes />
    </AppProviders>
  );
}
